import axios from "axios";
import { message } from "antd"; // eslint-disable-line no-unused-vars -- used in showAuthExpiredToastOnce
export const ACCESSTOKEN = "token";
export const ACCESSTOKEN_LAZADA = "token_lazada";
export const settings = {
  setStorageJson: (name, data) => {
    data = JSON.stringify(data);
    localStorage.setItem(name, data);
  },
  setStorage: (name, data) => {
    localStorage.setItem(name, data);
  },
  getStorageJson: (name) => {
    if (localStorage.getItem(name)) {
      const data = JSON.parse(localStorage.getItem(name));
      return data;
    }
    return; //undefined
  },
  getStore: (name) => {
    if (localStorage.getItem(name)) {
      const data = localStorage.getItem(name);
      return data;
    }
    return; //undefined
  },
  setCookieJson: (name, value, days) => {
    var expires = "";
    if (days) {
      var date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      expires = "; expires=" + date.toUTCString();
    }
    value = JSON.stringify(value);
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
  },
  getCookieJson: (name) => {
    var nameEQ = name + "=";
    var ca = document.cookie.split(";");
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) === " ") c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) === 0) {
        try {
          return JSON.parse(c.substring(nameEQ.length, c.length));
        } catch (_) {
          return null;
        }
      }
    }
    return null;
  },
  setCookie: (name, value, days) => {
    var expires = "";
    if (days) {
      var date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      expires = "; expires=" + date.toUTCString();
    }
    var domain = "";
    try {
      var host = typeof window !== "undefined" ? window.location.hostname : "";
      if (host === "localhost" || host === "127.0.0.1") {
        domain = "; domain=" + host;
      }
    } catch (_) {}
    var secure = "";
    try {
      if (typeof window !== "undefined" && window.location.protocol === "https:") {
        secure = "; Secure";
      }
    } catch (_) {}
    document.cookie = name + "=" + (value || "") + expires + "; path=/; SameSite=Lax" + domain + secure;
  },
  delete_cookie: (name) => {
    var domain = "";
    try {
      var host = typeof window !== "undefined" ? window.location.hostname : "";
      if (host === "localhost" || host === "127.0.0.1") {
        domain = "; domain=" + host;
      }
    } catch (_) {}
    document.cookie =
      name + "=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;" + domain;
  },
  getCookie: (name) => {
    var nameEQ = name + "=";
    var ca = document.cookie.split(";");
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) === " ") c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  },
  eraseCookie: (name) => {
    document.cookie =
      name + "=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
  },
  clearAllClientCookies: () => {
    var all = document.cookie ? document.cookie.split(";") : [];
    for (var i = 0; i < all.length; i++) {
      var cookie = all[i];
      var eqPos = cookie.indexOf("=");
      var name = eqPos > -1 ? cookie.substr(0, eqPos).trim() : cookie.trim();
      if (!name) continue;
      settings.delete_cookie(name);
      document.cookie = name + "=; Path=/; Max-Age=0";
    }
  },
};
export const libraries = ["places"];

// Khi truy cập từ điện thoại (LAN IP), API URL phải dùng cùng host thay vì localhost
function getApiBaseURL() {
  const url = process.env.REACT_APP_API_URL || "";
  if (!url) return url;
  try {
    const isLocal =
      url.includes("localhost") || url.includes("127.0.0.1");
    if (isLocal && typeof window !== "undefined") {
      const u = new URL(url);
      u.hostname = window.location.hostname;
      return u.origin;
    }
  } catch (_) {}
  return url;
}

// Backend route prefix là /api; baseURL phải kết thúc bằng /api để path như /check-login thành /api/check-login
function getAxiosBaseURL() {
  const base = getApiBaseURL();
  if (!base) return base;
  const normalized = base.replace(/\/+$/, "");
  return normalized.endsWith("/api") ? normalized : normalized + "/api";
}

export const apiBaseURL = getAxiosBaseURL();

//Setup hằng số, 1 số hàm xử lý chung, ...
export const http = axios.create({
  baseURL: apiBaseURL, //tất cả các hàm khi gọi api đều sử dụng domain này
  timeout: 60000,
  withCredentials: true,
});
//Cấu hình cho request: Client gửi api đến server
// user_token: HttpOnly cookie, không set Authorization từ JS; backend InjectJwtFromCookie copy cookie -> header
http.interceptors.request.use(
  (config) => {
    config.headers = {
      ...config.headers,
      TokenSendo: settings.getCookie(ACCESSTOKEN),
      TokenTiktok: settings.getCookie("access_tokenTikTok"),
      "tiki-token": settings.getCookie("access_tokenTiki") || ""
    };
    return config;
  },
  (err) => {
    return Promise.reject(err);
  }
);
// Token refresh state machine — prevents race conditions when multiple 401s arrive
// simultaneously. All concurrent 401s share the same refresh promise (audit 2026-03).
let tokenState = "idle"; // idle | refreshing | redirected
let refreshPromise = null;
let didShowAuthExpiredToast = false;

function clearRedirect401Flag() {
  tokenState = "idle";
  refreshPromise = null;
  didShowAuthExpiredToast = false;
}
export { clearRedirect401Flag };

const AUTH_CRITICAL_ENDPOINTS = ["/detail-user", "/check-login"];

function showAuthExpiredToastOnce() {
  if (didShowAuthExpiredToast) return;
  didShowAuthExpiredToast = true;
  message.error("Phiên đăng nhập hết hạn. Vui lòng đăng nhập lại.");
}

function isAuthCriticalRequest(config) {
  const url = config?.url || config?.baseURL || "";
  return AUTH_CRITICAL_ENDPOINTS.some((endpoint) => url.includes(endpoint));
}

/**
 * Factory: 401 interceptor for any axios instance. Retry uses the same instance that got 401.
 * Refresh always via http.post (shared state).
 * Post-refresh retry 401: only redirect for auth-critical endpoints; others reject without redirect.
 */
function create401ResponseInterceptor(instance) {
  return async (error) => {
    const status = error?.response?.status;
    if (status !== 401) return Promise.reject(error);

    const loginPath = "/login";
    // Post-refresh retry still 401: redirect only for auth-critical endpoints
    if (error.config?.__retriedAfterRefresh) {
      tokenState = "redirected";
      const shouldRedirect = isAuthCriticalRequest(error.config);
      if (shouldRedirect) {
        showAuthExpiredToastOnce();
        if (window.location.pathname !== loginPath) window.location.href = loginPath;
      }
      return Promise.reject(error);
    }
    if (error.config?.skipAuthRedirect) return Promise.reject(error);
    if (tokenState === "redirected") return Promise.reject(error);
    // Đang ở trang login: không gọi refresh-token, tránh lộ API
    if (typeof window !== "undefined" && window.location.pathname === loginPath)
      return Promise.reject(error);

    if (tokenState !== "refreshing") {
      tokenState = "refreshing";
      refreshPromise = http
        .post("/refresh-token", {}, { skipAuthRedirect: true })
        .then((res) => {
          tokenState = "idle";
          setTimeout(() => { refreshPromise = null; }, 100);
          return true;
        })
        .catch(() => {
          tokenState = "redirected";
          refreshPromise = null;
          showAuthExpiredToastOnce();
          if (window.location.pathname !== loginPath) window.location.href = loginPath;
          throw new Error("refresh_failed");
        });
    }

    return refreshPromise
      .then((ok) => {
        if (!ok) return Promise.reject(error);
        const cfg = error.config;
        cfg.skipAuthRedirect = true;
        cfg.__retriedAfterRefresh = true;
        return instance(cfg);
      })
      .catch(() => Promise.reject(error));
  };
}

//cấu hình cho response: Server sẽ trả dữ liệu về cho client
http.interceptors.response.use(
  (response) => response,
  create401ResponseInterceptor(http)
);

// setup hàm sử lý lazada
export const httplazada = axios.create({
  baseURL: apiBaseURL,
  timeout: 30000,
  withCredentials: true,
});
httplazada.interceptors.request.use(
  (config) => {
    config.headers = {
      ...config.headers,
      TokenLazada: settings.getCookie(ACCESSTOKEN_LAZADA),
      Token: settings.getCookie("access_token_vnp"),
    };
    return config;
  },
  (err) => {
    return Promise.reject(err);
  }
);
httplazada.interceptors.response.use(
  (response) => response,
  create401ResponseInterceptor(httplazada)
);

export const https = axios.create({
  baseURL: apiBaseURL, //tất cả các hàm khi gọi api đều sử dụng domain này
  withCredentials: true,
});
//Cấu hình cho request: Client gửi api đến server
https.interceptors.request.use(
  (config) => {
    config.headers = { ...config.headers };
    return config;
  },
  (err) => {
    return Promise.reject(err);
  }
);
//cấu hình cho response: Server sẽ trả dữ liệu về cho client
https.interceptors.response.use(
  (response) => response,
  create401ResponseInterceptor(https)
);
